import React, { useState } from "react";
import { ChevronDownIcon, DocumentIcon } from "@heroicons/react/20/solid";
import { useNavigate } from "react-router-dom";

const SidebarMenu = ({ menu, onClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const toggleMenu = () => {
    if (menu.subMenus && menu.subMenus.length > 0) {
      setIsOpen(!isOpen);
    } else {
      navigate(menu.link);
    }
  };

  return (
    <div>
      <button
        onClick={toggleMenu}
        className="flex items-center justify-between w-full px-4 py-4 rounded hover:bg-gray-200"
      >
        <div className="flex items-center space-x-3">
          {menu.icon && <menu.icon className="h-5 w-5 text-gray-600" />}
          <span className="text-gray-700">{menu.label}</span>
        </div>
        {menu.subMenus && (
          <ChevronDownIcon
            className={`h-4 w-4 text-gray-600 transform transition-transform duration-300 ${
              isOpen ? "rotate-180" : "rotate-0"
            }`}
          />
        )}
      </button>
      {isOpen && menu.subMenus && (
        <div className="pl-8 mt-2 space-y-5">
          {menu.subMenus.map((subMenu, index) => (
            <div key={index} className="flex items-center space-x-2">
              {/* Icône du sous-menu */}
              <div>
                {subMenu.icon ? (
                  React.isValidElement(subMenu.icon) ? (
                    subMenu.icon
                  ) : (
                    React.createElement(subMenu.icon, {
                      className: "h-5 w-5 text-muted",
                    })
                  )
                ) : (
                  <DocumentIcon className="h-5 w-5 text-muted" />
                )}
              </div>

              {/* Lien du sous-menu */}
              <a
                href={subMenu.link}
                className="block text-muted hover:text-gray-800 hover:underline"
              >
                {subMenu.label}
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SidebarMenu;
